module.exports = "/_next/static/images/bcd30f4734cc931824e6f0529ddbf9b9-pj-man-in-denim-jacket@xl.jpg";